import { keyframes } from '@emotion/core';

export const shakeLittle = keyframes`
  2% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  4% {
    transform: translate(0px, 1px) rotate(0.5deg);
  }

  6% {
    transform: translate(0px, 1px) rotate(0.5deg);
  }

  8% {
    transform: translate(1px, 0px) rotate(0.5deg);
  }

  10% {
    transform: translate(0px, 0px) rotate(0.5deg);
  }

  12% {
    transform: translate(1px, 0px) rotate(0.5deg);
  }

  14% {
    transform: translate(1px, 0px) rotate(0.5deg);
  }

  16% {
    transform: translate(0px, 1px) rotate(0.5deg);
  }

  18% {
    transform: translate(0px, 1px) rotate(0.5deg);
  }

  20% {
    transform: translate(0px, 1px) rotate(0.5deg);
  }

  22% {
    transform: translate(0px, 1px) rotate(0.5deg);
  }

  24% {
    transform: translate(0px, 0px) rotate(0.5deg);
  }

  26% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  28% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  30% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  32% {
    transform: translate(1px, 0px) rotate(0.5deg);
  }

  34% {
    transform: translate(0px, 1px) rotate(0.5deg);
  }

  36% {
    transform: translate(0px, 1px) rotate(0.5deg);
  }

  38% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  40% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  42% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  44% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  46% {
    transform: translate(1px, 0px) rotate(0.5deg);
  }

  48% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  50% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  52% {
    transform: translate(1px, 0px) rotate(0.5deg);
  }

  54% {
    transform: translate(0px, 1px) rotate(0.5deg);
  }

  56% {
    transform: translate(0px, 0px) rotate(0.5deg);
  }

  58% {
    transform: translate(0px, 0px) rotate(0.5deg);
  }

  60% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  62% {
    transform: translate(0px, 0px) rotate(0.5deg);
  }

  64% {
    transform: translate(1px, 0px) rotate(0.5deg);
  }

  66% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  68% {
    transform: translate(1px, 0px) rotate(0.5deg);
  }

  70% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  72% {
    transform: translate(0px, 0px) rotate(0.5deg);
  }

  74% {
    transform: translate(1px, 0px) rotate(0.5deg);
  }

  76% {
    transform: translate(0px, 1px) rotate(0.5deg);
  }

  78% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  80% {
    transform: translate(0px, 0px) rotate(0.5deg);
  }

  82% {
    transform: translate(1px, 0px) rotate(0.5deg);
  }

  84% {
    transform: translate(0px, 0px) rotate(0.5deg);
  }

  86% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  88% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  90% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  92% {
    transform: translate(0px, 0px) rotate(0.5deg);
  }

  94% {
    transform: translate(1px, 1px) rotate(0.5deg);
  }

  96% {
    transform: translate(0px, 1px) rotate(0.5deg);
  }

  98% {
    transform: translate(0px, 0px) rotate(0.5deg);
  }

  0%,
  100% {
    transform: translate(0, 0) rotate(0);
  }
`;

export const moveUp = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-30px);
  }

  100% {
    transform: translateY(-150px);
  }
`;

export const tilt = keyframes`
  0% {
    transform: rotate(0);
  }

  30% {
    transform: rotate(40deg);
  }
  100% {
    transform: rotate(60deg);
  }
`;

export const space = keyframes`
  0% {
    opacity: 0;
  }

  50%, 100% {
    opacity: 1;
  }
`;

export const dropFirstStage = keyframes`
  0% {
    transform: translate(0, 0) rotate(0) scale(1);
  }

  100% {
    transform: translate(10px, 350px) rotate(10deg) scale(0.6);
    opacity: 0;
  }
`;

export const dropInterStage = keyframes`
  0% {
    transform: translate(0, 0) rotate(0) scale(1);
  }

  100% {
    transform: translate(-10px, 380px) rotate(-15deg) scale(0.4);
    opacity: 0;
  }
`;

export const dropSecondStage = keyframes`
  0% {
    transform: translate(0, 0) rotate(0) scale(1);
  }


  100% {
    transform: translate(-10px, 280px) rotate(10deg) scale(0.3);
    opacity: 0;
  }
`;

export const moveDown = keyframes`
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(137px);
  }
`;

export const moveClouds = keyframes`
  0% {
    margin-top: -70%;
  }

  100% {
    margin-top: 0;
    margin-left:-70%
  }
`;

export const flashMove = keyframes`
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(0, -600px);
  }
`;

export const towerLean = keyframes`
  0% {
    transform: translate(0, 0) rotate(0) scale(1);
    transform-origin: bottom left;
  }
  100% {
    transform: translate(0, 100px) rotate(-20deg) scale(1);
    transform-origin: bottom left;
    opacity: 0.0;
  }
`;

export const launchPadMove = keyframes`
  0% {
    transform: translate(0, 0) rotate(0) scale(1);
  }

  100% {
    transform: translate(0, 100px) scale(1);
    opacity: 0;
  }
`;

export const moveIn = keyframes`
0% {
  transform: translate(0, 800px) rotate(0) scale(1);
}

100% {
  transform: translate(0, 75px) scale(1);
 
}
`;
export const flicker = keyframes`
from {
    opacity: 0.5;
  }
  4% {
    opacity: 0.5;
  }
  6% {
    opacity: 0.45;
  }
  8% {
    opacity: 0.55;
  }
  10% {
    opacity: 0.45;
  }
  11% {
    opacity: 0.5;
  }
  12% {
    opacity: 0.65;
  }
  14% {
    opacity: 0.55;
  }
  16% {
    opacity: 0.7;
  }
  17% {
    opacity: 0.55;
  }
  19% {
    opacity: 0.5;
  }
  20% {
    opacity: 0.5;
  }
  24% {
    opacity: 0.5;
  }
  26% {
    opacity: 0.69;
  }
  28% {
    opacity: 0.5;
  }
  38% {
    opacity: 0.45;
  }
  40% {
    opacity: 0.5;
  }
  42% {
    opacity: 0.6;
  }
  44% {
    opacity: 0.5;
  }
  46% {
    opacity: 0.5;
  }
  56% {
    opacity: 0.5;
  }
  58% {
    opacity: 0.75;
  }
  60% {
    opacity: 0.5;
  }
  68% {
    opacity: 0.5;
  }
  70% {
    opacity: 0.6; /*peak*/
  }
  72% {
    opacity: 0.5;
  }
  93% {
    opacity: 0.5;
  }
  95% {
    opacity: 0.6; /*peak*/
  }
  97% {
    opacity: 0.5;
  }
  to {
    opacity: 0.5;
  }
`;
